import { render, staticRenderFns } from "./PricingCardGuaranteeWrapper.vue?vue&type=template&id=4789573a&scoped=true&"
import script from "./PricingCardGuaranteeWrapper.vue?vue&type=script&lang=js&"
export * from "./PricingCardGuaranteeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PricingCardGuaranteeWrapper.vue?vue&type=style&index=0&id=4789573a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789573a",
  null
  
)

export default component.exports